export enum ManagementTypes {
    EXTERNAL = 'external',
    EXTERNAL_FOR_ACTION = 'external_for_action'
}
